'use client';

import Link from 'next/link';

import type { Cookie, Treasurer } from '@personly/libs-types';

const toDomains = (cookie: Cookie) => {
  if (cookie.groupHandle === 'HOST') {
    return Object.keys(cookie.domains).reduce((acc: string[], host) => {
      const i = acc.findIndex((e) => e === host);
      if (i === -1) return [...acc, host];
      return acc;
    }, []);
  } else if (cookie.groupHandle === 'DOMAIN') {
    return Object.keys(cookie.domains).reduce((acc: string[], host) => {
      const value = cookie.domains[host];
      const i = acc.findIndex((e) => e === value);
      if (i === -1) return [...acc, value];
      return acc;
    }, []);
  }

  return [];
};

interface Props {
  cookie: Cookie;
  treasurer: Treasurer;
}

const CookieService = ({ cookie, treasurer }: Props) => (
  <div className="flex flex-col text-center p-0 md:py-2">
    {cookie.service !== treasurer.name && (
      <div className="font-bold underline text-center">
        <Link href={cookie.url}>{cookie.service}</Link>
      </div>
    )}
    {toDomains(cookie).map((domain) => (
      <div key={domain}>{domain}</div>
    ))}
  </div>
);

export default CookieService;
